import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/finance.css';
import App from './App';
import { SuiProvider } from './sui';

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  <SuiProvider>
    <App />
  </SuiProvider>
);
